module.exports = __webpack_public_path__ + "media/src/images/icons/file_types/jpeg-82faa2c06bd301a6a80f3eaf4bf14236.svg";